<div class="col-sm-12 no-padding">
  <div class="accordion" id="accordion2Vacation">
    <div class="accordion-group">
      <div class="accordion-heading">
        <button (click)="toggleAccordionVacation()" class="accordion-toggle btn btn-link btn-block clearfix accordion-btn" data-toggle="collapse" data-parent="#accordion2Vacation" href="#collapseOneVacation">
          <div class="row">
            <div class="pull-left font-weight-light bp-text bp-small-text col-md-8 text-align-left no-padding"><i class="fas arrowdiv-vacation arrowdiv fa-chevron-right"></i> VACATION ALERTS</div>
            <div *ngIf="textSubscribedVacation || emailSubscribedVacation" class="col-md-4 green text-align-right">Subscribed</div>
            <div *ngIf="!textSubscribedVacation && !emailSubscribedVacation" class="col-md-4"></div>
          </div>
        </button>
      </div>
      <div id="collapseOneVacation" class="accordion-body collapse">
        <div class="row">
          <div class="col-sm-12 no-padding">
            <p class="text-align-left title-small font-weight-light bp-text bp-x-small-text">
              This alert is designed to allow you to have alerts scheduled while you are away on vacation. Simply enter the date range you will be away from home and set a water usage amount trigger. If there is water usage beyond what you have set as the trigger point, you will be alerted once you configure and subscribe to this alert.
            </p>
          </div>
        </div>
        <div class="accordion-inner">
          <div *ngIf="!subscribedVacation" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <button type="button" class="btn btn-light bp-text bp-medium-text" style="font-weight: 600;color: #3F8F8B;" (click)="onSubscribeClickVacation()">+ SUBSCRIBE</button>
            </div>
          </div>
          <div *ngIf="subscribedVacation" class="row subscribeSection">
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-6">
                <label for="datePickerStart" class="bp-text">Vacation Start Date:</label>
                <dx-date-box [(value)]="startTimeVacation"
                             [min]="minDateVacation"
                             type="date"
                             pickerType="calendar"
                             style="display: inline-block; padding-right: 0; width: 200px !important; margin: 5px 5px 10px 5px !important;"
                             id="datePickerStart">
                </dx-date-box>
                <br />
                <small *ngIf="isStartDateEmpty" class="red">Start Date Cannot Be Left Blank.</small>
              </div>

              <div class="col-sm-6">
                <label for="datePickerEnd" class="bp-text">Vacation End Date:</label>
                <dx-date-box [(value)]="endTimeVacation"
                             [min]="startTimeVacation"
                             type="date"
                             pickerType="calendar"
                             style="display: inline-block; padding-right: 0; width: 200px !important; margin: 5px 5px 10px 5px !important;"
                             id="datePickerEnd">
                </dx-date-box>
                <br />
                <small *ngIf="isEndDateEmpty" class="red">End Date Cannot Be Left Blank.</small>
              </div>
            </div>

            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12">
                <label for="vacationBuffer" class="bp-text">Hourly Water Usage Alarm Trigger:</label>
                <select id="vacationBuffer" class="form-control buffer-input" name="vacationBuffer" [(ngModel)]="vacationBuffer" (change)="setVacationBuffer($event.target.value)">
                  <option [value]="0">-Select Option-</option>
                  <option [value]=".1">.1 Gallon</option>
                  <option [value]=".5">.5 Gallon</option>
                  <option [value]="1">1 Gallon</option>
                  <option [value]="5">5 Gallons</option>
                  <option [value]="10">10 Gallons</option>
                </select>
              </div>
            </div>

            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><span class="bp-text bp-small-text">Contact Type:</span></div>
              <div class="col-sm-12">
                <div class="btn-group">
                  <label class="btn btn-primary subscription-container" (click)="showEmailInput()"
                         btnRadio="email" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="far fa-envelope"></i>Email</label>
                  <label class="btn btn-primary subscription-container" (click)="showPhoneSelect()"
                         btnRadio="text" tabindex="0" role="button"><i style="margin-right: 0.3rem;" class="fas fa-mobile-alt"></i>Text</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12"><span style="float:left;" class="bp-text bp-small-text">Destination:</span></div>
            </div>
            <div class="row" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12 bp-text bp-small-text">
                <div *ngIf="showPhoneVacation" class="form-group">
                  <span>
                    <select class="form-control select-medium" name="phone" [(ngModel)]="accountPhoneVacation">
                      <option *ngFor="let phone of accountPhonesVacation" [value]="phone">{{ phone }}</option>
                    </select>
                  </span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="textSubscribedVacation"> (Text Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="textSubscribedVacation" (click)="removeVacationAlert(true, false)" value="Remove Text Alerts" />
                  </div>
                </div>
                <div *ngIf="showEmailVacation">
                  <span class="bp-text bp-bold-text" *ngIf="showEmailVacation">{{accountEmailVacation}}</span>
                  <div class="margin-top-10">
                    <small class="green" *ngIf="emailSubscribedVacation"> (Email Subscribed)</small>
                    <input type="text" class="btn btn-xs btn-danger float-right" *ngIf="emailSubscribedVacation" (click)="removeVacationAlert(false, true)" value="Remove Email Alerts" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row bp-text bp-small-text" style="margin-left: 0.5rem;margin-bottom: 1.0rem;">
              <div class="col-sm-12"><button (click)="onSaveVacationAlertClick()" class="btn btn-primary" type="button">SAVE</button></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/vacaction-alert/vacaction-alert.component.html